// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section__2AdS3","external-switch":"style_external-switch__29goF"};